<template>
    <div class="wrapper">
        <notifications></notifications>
        <side-bar>
            <template slot-scope="props" slot="links">
                <sidebar-item
                    :link="{
                        name: 'Dashboard',
                        icon: 'fa fa-chart-pie text-primary',
                        path: '/backoffice/reports/dashboard'
                    }"
                    v-if="isAccessPayment"
                >
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_order_form,
                        icon: 'fa fa-shopping-cart text-blue',
                        path: '/backoffice/orders/create'
                    }"
                    v-if="isAccessOrder"
                >
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_order,
                        icon: 'fa fa-tasks text-primary',
                        path: '/backoffice/orders'
                    }"
                    v-if="isAccessOrder"
                >
                </sidebar-item>


				<sidebar-item
                    :link="{
                        name: menu_payment,
                        icon: '	fab fa-btc text-red',
                        path: '/backoffice/payments'
                    }"
                    v-if="isAccessPayment"
                >
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_packing,
                        icon: 'fa fa-car text-primary',
                        path: '/backoffice/packings'
                    }"
                    v-if="isAccessPacking"
                >
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_order_return,
                        icon: 'fa fa-car text-red',
                        path: '/backoffice/packings/shipping/return'
                    }"
                    v-if="isAccessOrderReturn"
                >
                </sidebar-item>


				<!-- <sidebar-item
                    :link="{
                        name: menu_customer,
                        icon: 'fa fa-user text-green',
                        path: '/backoffice/customers'
                    }"
                    v-if="isAccessCustomer"
                >
                </sidebar-item> -->

                <sidebar-item
                    :link="{
                        name: menu_report,
                        icon: 'fa fa-file text-info',
                        path: '/backoffice/reports'
                    }"
                    v-if="isAccessReport"
                >
					<sidebar-item :link="{ name: menu_report_team, icon: 'fa fa-file text-info', path: '/backoffice/reports/team' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_sale_chnanel, icon: 'fa fa-file text-info', path: '/backoffice/reports/sale-channel' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_product, icon: 'fa fa-file text-info', path: '/backoffice/reports/product' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_user, icon: 'fa fa-file text-info', path: '/backoffice/reports/user' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_user_product, icon: 'fa fa-file text-info', path: '/backoffice/reports/user-product' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_wms_summary, icon: 'fa fa-file text-info', path: '/backoffice/reports/summary-wms' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_wms_product_summary, icon: 'fa fa-file text-info', path: '/backoffice/reports/summary-wms-product' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_wms_field_summary, icon: 'fa fa-file text-info', path: '/backoffice/reports/summary-wms-field' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_commission, icon: 'fa fa-file text-info', path: '/backoffice/reports/commission' }" v-if="isAdmin" > </sidebar-item>
					
                </sidebar-item>

                <sidebar-item
                    :link="{
                        name: menu_platform,
                        icon: 'fa fa-database text-info',
                        path: '/platform/tiktok'
                    }"
                    v-if="isAccessPlatform"
                >
                </sidebar-item>

                <sidebar-item
                    :link="{
                        name: menu_inventory,
                        icon: 'fa fa-database text-info',
                        path: '/wms/inventory'
                    }"
                    v-if="isAccessWms"
                >
                    <sidebar-item
                        :link="{
                            name: menu_inventory_dashboard,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/dashboard'
                        }"
                        v-if="isAccessWms"
                    >
                    </sidebar-item>
					<sidebar-item
                        :link="{
                            name: menu_inventory_list,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/summary'
                        }"
                        v-if="isAccessWms"
                    >
                    </sidebar-item>
					
                    <sidebar-item
                        :link="{
                            name: menu_inventory_list_detail,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/detail'
                        }"
                        v-if="isAccessWms"
                    >
                    </sidebar-item>

                    <sidebar-item
                        :link="{
                            name: menu_inventory_history,
                            icon: 'fa fa-bullhorn text-info',
                            path: '/wms/history'
                        }"
                        v-if="IsEmployee"
                    >
                    </sidebar-item>
					<sidebar-item
                        :link="{
                            name: menu_inventory_history_storage_list,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/storage'
                        }"
                        v-if="isAccessWms"
                    >
                    </sidebar-item>
                    <sidebar-item
                        :link="{
                            name: menu_partner,
                            icon: 'fa fa-id-card text-blue',
                            path: '/wms/partner'
                        }"
                        v-if="isAdmin"
                    >
                    </sidebar-item>
                    <sidebar-item
                        :link="{
                            name: menu_product,
                            icon: 'fa fa-cube text-red',
                            path: '/wms/product'
                        }"
                        v-if="isAdmin"
                    >
                    </sidebar-item>
					<sidebar-item
                        :link="{
                            name: menu_product_wait_ship,
                            icon: 'fa fa-cube text-red',
                            path: '/wms/product/waitship'
                        }"
                        v-if="IsEmployee"
                    >
                    </sidebar-item>
                    <sidebar-item
                        :link="{
                            name: menu_storage,
                            icon: 'fa fa-tasks text-primary',
                            path: '/wms/storage'
                        }"
                        v-if="isAdmin"
                    >
                    </sidebar-item>
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_express,
                        icon: 'fa fa-cars text-error',
                        path: '/express'
                    }"
                    v-if="isAccessExpress"
                >

					<sidebar-item
                        :link="{
                            name: menu_express_list,
                            icon: 'fa fa-tasks text-primary',
                            path: '/express'
                        }"
                        v-if="isAccessExpress"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_express_form,
                            icon: 'fa fa-tasks text-primary',
                            path: '/wms/storage'
                        }"
                        v-if="isAccessExpress"
                    >
					</sidebar-item>

				</sidebar-item>

				<sidebar-item
                        :link="{
                            name: menu_admin,
                            icon: 'fa fa-tasks text-primary',
                            path: '/admin'
                        }"
                        v-if="isAdmin"
                    >
					<sidebar-item
                        :link="{
                            name: menu_user,
                            icon: 'fa fa-tasks text-primary',
                            path: '/admin/user'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>
					<sidebar-item
                        :link="{
                            name: menu_platform_connect,
                            path: '/admin/platform'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_sale_channel,
                            path: '/admin/sale-channel'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_admin_product,
                            path: '/admin/product'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_payment_channel,
                            path: '/admin/payment'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>



                    </sidebar-item>
            </template>
        </side-bar>
        <div class="main-content">
            <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

            <div @click="$sidebar.displaySidebar(false)">
                <fade-transition
                    :duration="200"
                    origin="center top"
                    mode="out-in"
                >
                    <!-- your content here -->
                    <router-view></router-view>
                </fade-transition>
            </div>
            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
        </div>
    </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
    if (hasElement(className)) {
		console.log("New perfect scroolbar",className)
        new PerfectScrollbar(`.${className}`);
    } else {
        // try to init it later in case this component is loaded async
		console.log("try to init it later in case ",className)
        setTimeout(() => {
            initScrollbar(className);
        }, 2000);
    }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import { mapGetters, mapActions } from "vuex";

export default {
    components: {
        DashboardNavbar,
        ContentFooter,
        DashboardContent,
        FadeTransition
    },
    computed: {
        menu_user: function() {
            return this.$t("menu.user");
        },

        menu_admin: function() {
            return this.$t("menu.admin");
        },

		menu_platform_connect: function() {
            return this.$t("menu.admin_platform_connect");
        },

        // ==========================================================
        // Backoffice Module
        // ==========================================================
		menu_order_form : function() {
			return this.$t("order_form");
		},
        menu_order: function() {
            return this.$t("orders");
        },

		

        menu_payment: function() {
            return this.$t("payment_check");
        },

		menu_payment_agent: function() {
            return this.$t("payment_check") + " (ตัวแทน)";
        },


        menu_payment_channel: function() {
            return this.$t("payment_channel");
        },

        menu_packing: function() {
            return this.$t("packings");
        },
		menu_order_return: function() {
            return this.$t("order_return");
        },


		menu_customer: function() {
			return this.$t("customer_information");
		},

        menu_report: function() {
            return this.$t("reports");
        },

		menu_report_team: function() {
			return this.$t("report_by_team");
		},

		menu_report_sale_chnanel: function() {
			return this.$t("report_by_sale_channel");
		},

		menu_report_product: function() {
			return this.$t("report_by_product");
		},

		menu_report_user: function() {
			return this.$t("report_by_user");
		},

		menu_report_user_product: function() {
			return this.$t("report_by_user_product");
		},

		menu_report_wms_summary: function() {
			return this.$t("report_wms_summary");
		},

		menu_report_wms_product_summary: function() {
			return this.$t("report_wms_product_summary");
		},
		menu_report_wms_field_summary: function() {
			return this.$t("report_wms_field_summary");
		},
		menu_report_commission: function() {
			return this.$t("report_commission");
		},




        menu_platfrom: function() {
            return this.$t("platform_connect");
        },

		menu_admin_product: function() {
			return this.$t("menu.admin_product");
		},

        // ==========================================================
        // WMS Module
        // ==========================================================
        menu_inventory_history: function() {
            return this.$t("wms.menu.inventory_history");
        },
        menu_promotion: function() {
            return this.$t("wms.menu.promotion");
        },
		menu_inventory_dashboard: function() {
            return this.$t("wms.menu.inventory_dashboard");
        },
        menu_inventory_list: function() {
            return this.$t("wms.menu.inventory_list");
        },
        menu_inventory_list_detail: function() {
            return this.$t("wms.menu.inventory_list_detail");
        },
        menu_inventory: function() {
            return this.$t("wms.menu.inventory");
        },
		menu_inventory_history_storage_list: function(){
			return this.$t("wms.menu.inventory_history_storage_list");
		},
        menu_partner: function() {
            return this.$t("wms.menu.partner");
        },
        menu_product: function() {
            return this.$t("wms.menu.product");
        },
		menu_product_wait_ship: function(){
			return "สินค้ารอส่ง"
		},
        menu_storage: function() {
            return this.$t("wms.menu.storage");
        },

		menu_sale_channel: function() {
            return this.$t("menu.sale_channel");
        },


        ...mapGetters({
            getUser: "Auth/getUser",
            isAccessWms: "Auth/isAccessWms",
            isAccessTiktok: "Auth/isAccessTiktok",
            isAccessOrder: "Auth/isAccessOrder",
            isAccessProduct: "Auth/isAccessProduct",
            isAccessPacking: "Auth/isAccessPacking",
            isAccessReport: "Auth/isAccessReport",
            isAccessPayment: "Auth/isAccessPayment",
            isAccessPlatform: "Auth/isAccessPlatform",
            isAccessDelivery: "Auth/isAccessDelivery",
			isAccessCustomer:  "Auth/isAccessCustomer",
			isAccessExpress: "Auth/isAccessExpress",
			isAccessOrderReturn: "Auth/isAccessOrderReturn",
			isAdmin:  "Auth/isAdmin"
        })
    },
    methods: {
        ...mapActions({
            setUser: "Auth/setUser",
            IsEmployee: "Auth/IsEmployee",
            IsReadonly: "Auth/IsReadonly"
        }),
        initScrollbar() {
            let isWindows = navigator.platform.startsWith("Win");
            if (isWindows) {
                initScrollbar("sidenav");
            }
        }
    },
    mounted() {
        this.initScrollbar();
    }
};
</script>
<style lang="scss">
.text-app {
    color: #19aaf8;
}
</style>
